import script from "./HomeEffect.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeEffect.vue?vue&type=script&setup=true&lang=js"

import "./HomeEffect.vue?vue&type=style&index=0&id=b75fb9b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b75fb9b2"]])

export default __exports__